import { useQuery } from '@tanstack/react-query'

import { getOrgProjectList } from '~/generated/client/'

export const QUERY_KEYS = {
  GET_ANALYTICS: (timePeriod: string) => ['analytics', timePeriod],
  GET_PROJECTS: 'GET_PROJECTS',
}

export function useProjectsQuery() {
  const { data, isLoading, isError, isSuccess, refetch } = useQuery({
    queryKey: [QUERY_KEYS.GET_PROJECTS],
    queryFn: getOrgProjectList,
    staleTime: 100 * 100000,
    refetchOnWindowFocus: false,
  })

  return {
    data: data?.data,
    isLoading,
    isError,
    isSuccess,
    refetch,
  }
}
